import PagerList from '@/components/PagerList.vue';

let dataMixin = {
    data() {
        return {
            objects: [],
            max_length: 100,
            size: 20,
            all_count: 0,
            page: 1,
            name: '',
            empty: {},
            validate: {},
            select: {},
            dicts: {},
            filters: {},
            modal_data: []
        }
    },
    components: {
        PagerList
    },
    computed: {
        pager() {
            return this.$func.getPagerArray(this.all_count, this.size, this.page)
        },
        current_page() {
            let pages = this.$store.getters.pages.filter((page) => {
                return page.slug === this.$route.name
            });
            return pages.length ? pages[0] : {}
        },

    },
    watch: {
        $route() {
            this.getData()
        },
        page: {
            deep: true,
            handler() {
                this.getData();
            }

        },
    },
    mounted: function () {

    },
    methods: {

    }
};
export default dataMixin;
